import { useState, useEffect } from 'react';

/**
 * Tracks the user's prefers-reduced-motion setting live, so motion can be
 * disabled immediately if they change it without a page reload.
 */
const usePrefersReducedMotion = () => {
  const [prefersReduced, setPrefersReduced] = useState(() =>
    typeof window !== 'undefined'
      ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
      : false
  );

  useEffect(() => {
    const mql = window.matchMedia('(prefers-reduced-motion: reduce)');
    const handler = (e) => setPrefersReduced(e.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return prefersReduced;
};

export default usePrefersReducedMotion;
